import { render, staticRenderFns } from "./MemoRemindSetting.vue?vue&type=template&id=5af6a36c&scoped=true"
import script from "./MemoRemindSetting.vue?vue&type=script&lang=js"
export * from "./MemoRemindSetting.vue?vue&type=script&lang=js"
import style0 from "./MemoRemindSetting.vue?vue&type=style&index=0&id=5af6a36c&prod&lang=css"
import style1 from "./MemoRemindSetting.vue?vue&type=style&index=1&id=5af6a36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6a36c",
  null
  
)

export default component.exports